import React, { useEffect } from 'react';
import './FounderTeamPage.scss'
import '../../../../../pages/styles.scss'
import tagSvg from '../../../../../../assets/images/WhoWeHelp/tag.svg'
import FooterSection from '../../../../../../components/reusable/HomePageSections/FooterSection/FooterSection.js';
import { Link } from 'react-router-dom';
import { teamMembers } from '../../../../../../components/reusable/Common/Constant.js';
import founderMainImage from '../../../../../../assets/images/Community/Founder.png'

const FounderTeamPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);
    return (
        <div className='founder-team-page-container container'>
            <div className='founder-team-page-section section-1'>
                <div className='founder-team-page-section-content text'>
                    <h1>Meet the Team: <span className="highlight">Founder</span></h1>
                    <p>The visionary leadership and entrepreneurial spirit behind the establishment and growth of Virginia Rehab Physicians.</p>
                    <div className='button-section'>
                        <a className='btn' href="/careers-and-culture">
                            <i className='bx bx-plus'></i>
                            Explore Career Opportunities
                        </a>
                    </div>
                </div>
                <div className='founder-team-page-section-content image'>
                    <div className='image-container'>
                        <img src={founderMainImage} alt="" />
                    </div>
                </div>
            </div>
            <div className='founder-team-page-section section-2'>
                <div className='founder-team-page-section-content text'>
                    <div className='company-vision-title'>
                        <div className='tag' style={{
                            backgroundImage: `url(${tagSvg})`,
                        }}>
                            <span>Our Team</span>
                        </div>
                        <br />
                        <h1>Founder</h1>
                    </div>
                    <div className='company-vision-para'>
                        <p>Driven by a passion for innovation and a vision for excellence, Dr. Jenkins founded the company with the goal of setting new industry standards. His dedication to quality has led him to build a dynamic team focused on achieving outstanding results while fostering a culture of collaboration and creativity. Under his leadership, the company continues to thrive, consistently inspiring progress and innovation at every stage.</p>
                    </div>
                </div>
                <hr className="section-divider" />
                <div className='founder-team-page-section-content text'>
                    <div className='company-vision-point bubble-point'>
                        <h2>Transparency</h2>
                    </div>
                    <div className='company-vision-point bubble-point'>
                        <h2>Feedback Driven</h2>
                    </div>
                    <div className='company-vision-point bubble-point'>
                        <h2>Professional Development Plans</h2>
                    </div>
                </div>
            </div>
            <div className='founder-team-page-section section-3'>
                <div className='founder-team-page-section-content image'>
                    <div className='image-container'>
                        <img src={teamMembers.randy.image} alt="" />
                    </div>
                    <h1>{teamMembers.randy.name}</h1>
                    <p>{teamMembers.randy.designation}</p>
                    <div className='button-section'>
                        <Link
                            className='btn-2'
                            to="/team-member-details"
                            state={{
                                image: teamMembers.randy.image,
                                pageType: teamMembers.randy.pageType,
                                name: teamMembers.randy.name,
                                designation: teamMembers.randy.designation,
                                message: teamMembers.randy.message,
                            }}
                        >
                            <i className='bx bx-right-arrow-alt' />
                            Read More
                        </Link>
                    </div>
                </div>
            </div>
            <FooterSection />
        </div>
    )
}

export default FounderTeamPage
